import { render } from "./A5Form.vue?vue&type=template&id=1452d5f2&scoped=true"
import script from "./A5Form.vue?vue&type=script&lang=js"
export * from "./A5Form.vue?vue&type=script&lang=js"

import "./A5Form.vue?vue&type=style&index=0&id=1452d5f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1452d5f2"]])

export default __exports__